import { render, staticRenderFns } from "./InfoContent.vue?vue&type=template&id=5d9099b8&scoped=true"
import script from "./InfoContent.vue?vue&type=script&lang=js"
export * from "./InfoContent.vue?vue&type=script&lang=js"
import style0 from "./InfoContent.vue?vue&type=style&index=0&id=5d9099b8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9099b8",
  null
  
)

export default component.exports